import * as React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormManager, PageTitle, Update, useCacheRecord } from 'gossamer-front-end';
import { InstitutionGroup } from 'cb-model';
import { getListRowLink } from 'gossamer-unified';

export const InstitutionGroupUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(InstitutionGroup, params.key);
  const handleExit = () => navigate(getListRowLink(InstitutionGroup.listRowLink, params.key));
  return (
    <>
      <PageTitle verb="Update" entity={InstitutionGroup} keyValue={params.key} />
      <FormManager
        compoundUrl="/main/~/institution-update"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: { type: 'update-single', entity: InstitutionGroup, record },
        }}
      >
        <Update valuesKey="main" entity={InstitutionGroup} />
      </FormManager>
    </>
  );
};
